<template>
  <div
    id="app"
    @contextmenu="onContextMenu"
    :style="{ 'cursor': env == 'production' ? 'none' : 'default' }"
  >
    <loader/>
    <notifications/>
    <div v-if="(componentReady && config) || standaloneRoute">
      <div
        class="app-container"
        :class="{ 'full-width' : standaloneRoute }">
        <router-view/>
      </div>
      <div
        v-if="showBetslip && !standaloneRoute"
        class="betslip-overlay"
        @click="toggleBetslip()"
      />
      <div
        v-if="betslipConfig && !standaloneRoute"
        class="betslip-container"
        :class="{ 'show-betslip': showBetslip }">
        <betslip />
      </div>
    </div>
  </div>
</template>

<script>
import Notifications from './components/shared/notifications/Notifications.vue';
import Betslip from './components/shared/betslip/Betslip.vue';
import gravityGateway from './services/gravityGateway';

export default {
  components: {
    Notifications,
    Betslip,
  },
  computed: {
    config() {
      const config = this.$store.getters.getProductConfig;
      if (config && config.rules) {
        gravityGateway.sendMessage('Slave.Loaded', {});
      }
      return config;
    },
    componentReady() {
      const company = this.$store.getters.getCompany;
      return company && company.uuid;
    },
    betslipConfig() {
      return this.$store.getters.getBetslipConfig;
    },
    env() {
      return this.$store.getters.getEnv;
    },
    showBetslip() {
      return this.$store.getters.getBetslipShow;
    },
    ticketHistoryRoute() {
      return this.$route.name === 'Tickets';
    },
    ticketCheckRoute() {
      return this.$route.name === 'TicketCheck';
    },
    standaloneRoute() {
      return this.ticketHistoryRoute || this.ticketCheckRoute;
    },
  },
  methods: {
    toggleBetslip() {
      this.$store.dispatch('toggleBetslip');
    },
    onContextMenu(e) {
      e.preventDefault();
    },
  },
};
</script>

<style lang="scss">
  @import './scss/default/icons';
  @import './scss/fonts';

  *,
  *:before,
  *:after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    background: #171717;
    color: #fff;
    font-family: $fontPrimary, sans-serif;
    user-select: none;
    font-size: 16px;
    overflow: hidden;
    cursor: none;
  }

  .app-container {
    float: left;
    width: 75%;

    &.full-width {
      width: 100%;
    }
  }

  .betslip-container {
    width: 25%;
    float: right;
    padding: 10px;
  }

  .header-menu {
    width: 100%;
    z-index: 1;
  }

  .sports-header {
    width: 100%;
    z-index: 1;
  }

  ::-webkit-scrollbar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 7px;
  }

  ::-webkit-scrollbar-thumb {
    background: rgba(#000, 0.5);
    border-radius: 5px;
  }

  @media all and(max-width: 1200px) {
  .app-container {
    width: 100%;
  }

  .betslip-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(#000, 0.6);
    z-index: 1000;
  }

  .betslip-container {
    position: absolute;
    overflow: hidden;
    // Width needs to be equal on live and prematch
    // This is equal to bootstrap's sm-11 class, used on live
    width: 45.8333333333%;
    padding: 0;
    top: 0;
    bottom: 0;
    left: 100%;
    transition: left 0.5s ease-in-out;
    z-index: 1001;

    .betslip {
      width: 100%;
      float: right;
    }

    &.show-betslip {
      left: (100% - 45.8333333333);
    }
  }
}
</style>
